{
  "(optional)": "(facultatif)",
  "(required)": "(requis)"
}